import React from 'react';
import { CaseStudyPresentation } from './components/CaseStudyPresentation';
export function App() {
  return <CaseStudyPresentation data-id="element-0" />;
}